import { IMongoDocument } from "utils/types"
import { CURRENCY } from "../balanceAPI/values"

export const NY_GIFT_MY_BEHAVIOR_TYPE = {
  NAUGHTY: "Naughty-Pup",
  GOOD: "Good-Boy",
  BEST: "Santa's-Best-Dog"
} as const
export type INyGiftMyBehaviorType =
  (typeof NY_GIFT_MY_BEHAVIOR_TYPE)[keyof typeof NY_GIFT_MY_BEHAVIOR_TYPE]

export interface IGift extends IMongoDocument {
  userId: string
  currency?: CURRENCY
  amount?: number
  claimed?: boolean
  claimedAt?: string
  claimableFrom?: string
  claimableTo?: string
  yourBehavior: INyGiftMyBehaviorType
}

export interface INyGiftMyBehavior {
  gift: IGift
}
